export default __webpack_public_path__ + "static/identyfikacja-a998d93f1008fc0ccaedfaa825371953.jpeg";